import axios from 'axios';

// Local Development
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Live Server (uncomment after deploying backend changes)
const API_BASE_URL = 'https://translation-ipa.avopla.ca/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Translation APIs (Restaurant website)
export const translationApi = {
  getAll: () => api.get('/translations'),
  getBySection: (section) => api.get(`/translations/section/${section}`),
  getFormatted: () => api.get('/translations/formatted'),
  create: (data) => api.post('/translations', data),
  bulkCreate: (translations) => api.post('/translations/bulk', { translations }),
  update: (id, data) => api.put(`/translations/${id}`, data),
  delete: (id) => api.delete(`/translations/${id}`),
};

// Customer Translation APIs (Customer website)
export const customerTranslationApi = {
  getAll: (section) => api.get('/customer-translations', { params: section ? { section } : {} }),
  getSections: () => api.get('/customer-translations/sections'),
  getBySection: (section) => api.get(`/customer-translations/section/${section}`),
  getExport: (section) => api.get('/customer-translations/export', { params: section ? { section } : {} }),
  create: (data) => api.post('/customer-translations', data),
  bulkCreate: (translations) => api.post('/customer-translations/bulk', { translations }),
  update: (id, data) => api.put(`/customer-translations/${id}`, data),
  delete: (id) => api.delete(`/customer-translations/${id}`),
};

// Image APIs
export const imageApi = {
  getAll: () => api.get('/images'),
  getBySection: (section) => api.get(`/images/section/${section}`),
  getByName: (name) => api.get(`/images/name/${name}`),
  getFormatted: () => api.get('/images/formatted'),
  upload: (formData) => api.post('/images/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  update: (id, data) => api.put(`/images/${id}`, data),
  replace: (id, formData) => api.put(`/images/${id}/replace`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete: (id) => api.delete(`/images/${id}`),
};

export default api;
